export default {
  /**
   * 終了済み
   */
  ENDED: 'ENDED',

  /**
   * 全ての申込枠が受付開始前
   */
  ENTRY_NOT_STARTED: 'ENTRY_NOT_STARTED',

  /**
   * 全ての申込枠が受付終了
   */
  ENTRY_CLOSED: 'ENTRY_CLOSED',

  /**
   * 申し込み可能
   */
  ACTIVE: 'ACT',

  /**
   * 非公開
   */
  PRIVATE: 'PRIVATE',

  /**
   * 満席（受付待機で申込可能）
   */
  WAITLIST: 'WAITLIST',
} as const
